module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "watch.8719eb8a.png";